module.exports = __webpack_public_path__ + "static/img/czy.7d96aaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/classmates/czy.png
// module id = lWfb
// module chunks = 42